import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import "./Chalan/Chalan.css";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import ReactToPrint from "react-to-print";
const style2 = {
  position: "absolute",
  height: "100%",
  overflow: "scroll",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
};

function Printewayform({ eway }) {
  let componentRef = useRef();
  const profileDetails = useSelector((state) => state.dataReducer.profile);
  const jsonDataString = window.localStorage.getItem("jsonData");
  const jsonData = JSON.parse(jsonDataString);
  let gstin;
  if (jsonData) {
    gstin = jsonData?.header?.gstin;
  } else gstin = "not available";

  console.log("eway:", eway);

  return (
    <>
      <div className="" ref={(el) => (componentRef = el)}>
        <div className="second" style={{ alignItems: "center" }}>
          <h3>E-WAY BILL Details</h3>
        </div>
        <div
          className="first  "
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
            // border: "1px solid black",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "10px",
              width: "100%",
            }}
          >
            <div>
              <p>eWay Bill No</p>
              <p>{eway?.eWay_Bill_No || "Not available"}</p>
            </div>
            <div>
              <p>Generated Date</p>
              <p>{eway?.ewayBillDate || "Not available"}</p>
            </div>
            <div>
              <p>Generated By:</p>
              <p>
                {profileDetails?.pro && profileDetails.pro.gst_no
                  ? profileDetails.pro.gst_no
                  : "---"}
              </p>
            </div>
            <div>
              <p>Valid Upto:</p>
              <p>{eway?.validUpto || "Not available"}</p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              padding: "10px",
              width: "100%",
            }}
          >
            {/* <div>
                  <p>mode</p>
                  <p>road</p>
                </div> */}
            <div>
              <p>mode</p>
              <p>
                {(() => {
                  switch (Number(eway?.transMode)) {
                    case 1:
                      return "road";
                    case 2:
                      return "rail";
                    case 3:
                      return "air";
                    case 4:
                      return "ship";
                    default:
                      return "---";
                  }
                })()}
              </p>
            </div>

            <div>
              <p>Approx Distance</p>
              <p>{eway?.transDistance}km</p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              padding: "10px",
              width: "100%",
            }}
          >
            <div>
              <p>Type</p>
              {(() => {
                let inwardType, skdCkdLotsType;
                if (eway?.supplyType === "I") {
                  inwardType = "inward";
                } else if (eway?.supplyType === "O") {
                  inwardType = "outward";
                }
                switch (Number(eway?.subSupplyType)) {
                  case 1:
                    skdCkdLotsType = "Supply";
                    break;
                  case 2:
                    skdCkdLotsType = "Import";
                    break;
                  case 3:
                    skdCkdLotsType = "Export";
                    break;
                  case 4:
                    skdCkdLotsType = "Job Work";
                    break;
                  case 5:
                    skdCkdLotsType = "For Own use";
                    break;
                  case 6:
                    skdCkdLotsType = "Job work Returns";
                    break;
                  case 7:
                    skdCkdLotsType = "Sales Return";
                    break;
                  case 8:
                    skdCkdLotsType = "Others";
                    break;
                  case 9:
                    skdCkdLotsType = "SKD/CKD/Lots";
                    break;
                  case 10:
                    skdCkdLotsType = "Line Sales";
                    break;
                  case 11:
                    skdCkdLotsType = "Recipient Not Known";
                    break;
                  case 12:
                    skdCkdLotsType = "Exhibition or Fairs";
                    break;
                  default:
                    skdCkdLotsType = "Unknown";
                    break;
                }

                return (
                  <p>
                    {inwardType} - {skdCkdLotsType}
                  </p>
                );
              })()}
            </div>
            <div>
              <p>Document Details</p>
              <p>
                {eway?.docType} - {eway?.docNo} - {eway?.docDate}
              </p>
            </div>
            <div>
              <p>Transaction Type</p>
              <p>
                {(() => {
                  switch (Number(eway?.transactionType)) {
                    case 1:
                      return "Regular";
                    case 2:
                      return "Bill To-Ship To";
                    case 3:
                      return "Bill From-Dispatch From";
                    case 4:
                      return "Combination of 2 and 3";
                    default:
                      return eway?.transactionType;
                  }
                })()}
              </p>
            </div>
          </div>
        </div>
        <div className="second" style={{ alignItems: "center" }}>
          <h3>2.Address Details</h3>
        </div>
        <div
          className="second1 "
          style={{
            height: "100%",
            display: "flex",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              width: "50%",
              paddingLeft: "10px",

              padding: "10px",
            }}
          >
            <p style={{ padding: "5px" }}>
              <b>From</b>{" "}
            </p>
            <div>
              <div>
                <p>gstin : {eway?.fromGstin}</p>
                <p>{eway?.fromTrdName}</p>
                <p>: Dispatch From ::</p>
                <p>
                  {eway?.fromAddr1} {eway?.fromPlace},
                  {(() => {
                    switch (Number(eway?.actFromStateCode)) {
                      case 1:
                        return "JAMMU AND KASHMIR";
                      case 2:
                        return "HIMACHAL PRADESH";
                      case 3:
                        return "PUNJAB";
                      case 4:
                        return "CHANDIGARH";
                      case 5:
                        return "UTTARAKHAND";
                      case 6:
                        return "HARYANA";
                      case 7:
                        return "DELHI";
                      case 8:
                        return "RAJASTHAN";
                      case 9:
                        return "UTTAR PRADESH";
                      case 10:
                        return "BIHAR";
                      case 11:
                        return "SIKKIM";
                      case 12:
                        return "ARUNACHAL PRADESH";
                      case 13:
                        return "NAGALAND";
                      case 14:
                        return "MANIPUR";
                      case 15:
                        return "MIZORAM";
                      case 16:
                        return "TRIPURA";
                      case 17:
                        return "MEGHALAYA";
                      case 18:
                        return "ASSAM";
                      case 19:
                        return "WEST BENGAL";
                      case 20:
                        return "JHARKHAND";
                      case 21:
                        return "ORISSA";
                      case 22:
                        return "CHHATTISGARH";
                      case 23:
                        return "MADHYA PRADESH";
                      case 24:
                        return "GUJARAT";
                      case 26:
                        return "DADAR AND NAGAR HAVELI & DAMAN AND DIU";
                      case 27:
                        return "MAHARASHTRA";
                      case 29:
                        return "KARNATAKA";
                      case 30:
                        return "GOA";
                      case 31:
                        return "LAKSHADWEEP";
                      case 32:
                        return "KERALA";
                      case 33:
                        return "TAMIL NADU";
                      case 34:
                        return "PUDUCHERRY";
                      case 35:
                        return "ANDAMAN AND NICOBAR";
                      case 36:
                        return "TELANGANA";
                      case 37:
                        return "ANDHRA PRADESH";
                      case 38:
                        return "LADAKH";
                      case 97:
                        return "OTHER TERRITORY";
                      case 99:
                        return "OTHER COUNTRY";
                      default:
                        return eway?.actFromStateCode;
                    }
                  })()}
                  -{eway?.fromPincode}
                </p>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              width: "50%",
              paddingLeft: "10px",
              padding: "10px",
            }}
          >
            <p style={{ padding: "5px" }}>
              {" "}
              <b>To</b>
            </p>
            <div>
              <p>gstin : {eway?.toGstin}</p>
              <p>{eway?.toTrdName}</p>
              <p>: Ship to ::</p>
              <p>
                {eway?.toAddr1} {eway?.toPlace},
                {(() => {
                  switch (Number(eway?.actToStateCode)) {
                    case 1:
                      return "JAMMU AND KASHMIR";
                    case 2:
                      return "HIMACHAL PRADESH";
                    case 3:
                      return "PUNJAB";
                    case 4:
                      return "CHANDIGARH";
                    case 5:
                      return "UTTARAKHAND";
                    case 6:
                      return "HARYANA";
                    case 7:
                      return "DELHI";
                    case 8:
                      return "RAJASTHAN";
                    case 9:
                      return "UTTAR PRADESH";
                    case 10:
                      return "BIHAR";
                    case 11:
                      return "SIKKIM";
                    case 12:
                      return "ARUNACHAL PRADESH";
                    case 13:
                      return "NAGALAND";
                    case 14:
                      return "MANIPUR";
                    case 15:
                      return "MIZORAM";
                    case 16:
                      return "TRIPURA";
                    case 17:
                      return "MEGHALAYA";
                    case 18:
                      return "ASSAM";
                    case 19:
                      return "WEST BENGAL";
                    case 20:
                      return "JHARKHAND";
                    case 21:
                      return "ORISSA";
                    case 22:
                      return "CHHATTISGARH";
                    case 23:
                      return "MADHYA PRADESH";
                    case 24:
                      return "GUJARAT";
                    case 26:
                      return "DADAR AND NAGAR HAVELI & DAMAN AND DIU";
                    case 27:
                      return "MAHARASHTRA";
                    case 29:
                      return "KARNATAKA";
                    case 30:
                      return "GOA";
                    case 31:
                      return "LAKSHADWEEP";
                    case 32:
                      return "KERALA";
                    case 33:
                      return "TAMIL NADU";
                    case 34:
                      return "PUDUCHERRY";
                    case 35:
                      return "ANDAMAN AND NICOBAR";
                    case 36:
                      return "TELANGANA";
                    case 37:
                      return "ANDHRA PRADESH";
                    case 38:
                      return "LADAKH";
                    case 97:
                      return "OTHER TERRITORY";
                    case 99:
                      return "OTHER COUNTRY";
                    default:
                      return eway?.actToStateCode;
                  }
                })()}
                -{eway?.toPincode}
              </p>
            </div>
          </div>
        </div>
        <div className="second" style={{ alignItems: "center" }}>
          <h3>3. Goods Details</h3>
        </div>
        <div className="second" style={{ height: "100%" }}>
          <table>
            <thead>
              <tr>
                <th>Product Name & Desc. </th>
                <th>HSN Code </th>
                <th>Quantity</th>
                <th>Taxable Amount Rs</th>
                <th>Tax Rate (C+S+I+Cess+Cess Non.Advol)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{eway?.productDesc}</td>
                <td>{eway?.hsnCode}</td>
                <td>{eway?.quantity}</td>
                <td>{eway?.taxableAmount}</td>
                <td>
                  {eway?.sgstRate +
                    "+" +
                    eway?.sgstRate +
                    "+" +
                    eway?.igstRate +
                    "+" +
                    eway?.cessRate +
                    "+" +
                    eway?.cessNonAdvol}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="second" style={{ height: "100%" }}>
          <table>
            <thead>
              <tr>
                <th>Tot. Tax'ble Amt </th>
                <th>CGST Amt</th>
                <th> SGST Amt</th>
                <th>IGST Amt</th>
                <th>CESS Amt</th>
                <th>CESS Non.Advol Amt </th>
                <th>Other Amt </th>
                <th>Total Inv.Amt</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td> {eway?.taxableAmount}</td>
                <td>{eway?.cgstValue}</td>
                <td>{eway?.sgstValue}</td>
                <td>{eway?.igstValue}</td>
                <td>{eway?.cessValue}</td>
                <td>{eway?.TolNonAdolVal}</td>
                <td>{eway?.OthValue}</td>
                <td>{eway?.totInvValue}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="second" style={{ alignItems: "center" }}>
          <h3>4. Transportation Details</h3>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            padding: "10px",
            width: "100%",
          }}
        >
          <div style={{ display: "flex" }}>
            <p>Transporter ID & Name : </p>
            <p> {eway?.transporterId + " & " + eway?.transporterName}</p>
          </div>
          <div style={{ display: "flex" }}>
            <p>Transporter Doc. No & Date</p>
            <p>{eway?.transDocNo + "&" + eway?.transDocDate}</p>
          </div>
        </div>
        <div className="second" style={{ alignItems: "center" }}>
          <h3>5. Vehicle Details</h3>
        </div>
        <div className="second" style={{ height: "100%" }}>
          <table>
            <thead>
              <tr>
                <th>Mode </th>
                <th>Vehicle / Trans Doc No & Dt.</th>
                <th>From</th>
                <th>Entered Date </th>
                <th>Entered By</th>
                <th>CEWB No. (If any)</th>
                <th>Multi Veh.Info (If any)</th>
              </tr>
            </thead>
            <tbody>
              {/* <tr>
                    <td> Road</td>
                    <td>NE+NE+18.000+0.000+0.00</td>
                    <td>42.23 MTS</td>
                    <td>713421.80 wedwq e </td>
                    <td>NE+NE+18.000+0.</td>
                    <td>-</td>
                    <td>-</td>
                  </tr> */}
              <tr>
                <td> Road</td>
                <td>
                  {eway?.vehicleNo} & {eway?.transDocNo} {eway?.transDocDate}
                </td>
                <td>{eway?.fromPlace}</td>
                <td>{eway?.ewayBillDate}</td>
                <td>
                  {profileDetails?.pro && profileDetails.pro.gst_no
                    ? profileDetails.pro.gst_no
                    : "---"}
                </td>
                <td>-</td>
                <td>-</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <ReactToPrint
        trigger={() => <button>Print this out!</button>}
        content={() => componentRef}
      />
    </>
  );
}

export default Printewayform;
